export const AMAZON_BOOK_LINKS = '/#';

export const TWITTER = '/#';
export const INSTAGRAM = 'https://www.instagram.com/rltookes/';
export const FACEBOOK = 'https://www.facebook.com/ryan.tookes';
export const LINKEDIN = 'https://www.linkedin.com/in/ryan-tookes-0a7b487/';